// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pFxys","questions":"styles_questions__3p_8w","footer":"styles_footer__3vuf5"};